import { useState, useEffect } from "react";
import { useIntl } from "react-intl";

const useStatus = (statuses, activePatient) => {
  const intl = useIntl();
  const [stagesValue, setStagesValue] = useState();

  // Generate stages based on statuses
  const stages = statuses
    ? statuses
        .sort((a, b) => a.sort_order - b.sort_order)
        .map((i) => {
          return {
            title: intl.formatMessage({
              id: `app.opportunities.${i.name}`,
            }),
          };
        })
    : [];

  useEffect(() => {
    if (statuses && statuses.length > 0) {
      const defaultStatusSortId = statuses.find(
        (i) => i.is_default === true
      ).sort_order;

      const statusSortId =
        activePatient && activePatient.opportunity_status_id
          ? statuses.find((i) => i.id === activePatient.opportunity_status_id)
              .sort_order
          : defaultStatusSortId;

      setStagesValue(statusSortId - 1);
    }
  }, [statuses, activePatient]);

  return { stagesValue, setStagesValue, stages };
};

export default useStatus;
